import { CalculationType } from '../enums';
import { CalculationInput } from './calculation-input';

export class StartRiskCalculationCommand {
    public locationId: string;
    public calculationInput: CalculationInput;
    public calculationType: CalculationType;

    public constructor(init: Partial<StartRiskCalculationCommand>) {
        Object.assign(this, init);
    }
}
